import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { EnvService } from './../env-friendly-service/env-friendly-service';
import { Nav } from 'ionic-angular';

interface AngularRequestOptions {
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    observe?: string;
    params?: HttpParams | {
        [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: string;
    withCredentials?: boolean;
}

@Injectable()

export class StubService {
    targetURL:string;
    nav: Nav;

    constructor(
        public events: Events,
        public http: HttpClient,
        public envService: EnvService
    )
    {
        this.targetURL = this.envService.getAppUrl();
    }

    sillyRegex = /[_]/g;
    requestMap = {};

    // methods
    async do(method: string = 'get', entity: string, query: string , data?: object, scope?: string, options: AngularRequestOptions = { }) {
        if (typeof options.withCredentials !== 'boolean')
        {
            options.withCredentials = true;
        }
        const token = window.localStorage.getItem('session');
        if (token)
        {
            if (!options.headers)
            {
                options.headers = { };
            }
            options.headers['Authorization'] = `Bearer ${ token }`;
        }
        // only store with query if doesn't include ~
        var storedCall = (typeof scope === 'string') ? scope : `${method}|${entity}`;
        if (query && query.includes('parallel=true'))
        {
            storedCall += `|${query}`;
        }
        else if (!scope) {
            // have to handle ~ specially
            if (query && (query.indexOf('/FilteredTo/') > -1)) {
                var tempQuery = '' + query;
                if (query.indexOf('/Lite') > -1) {
                    tempQuery = tempQuery.replace('/Lite', '');
                }
                if (query.indexOf('/Count') > -1) {
                    // get rid of count
                    tempQuery.replace('/Count', '');
                    tempQuery = tempQuery.substring(0, '/Count'.length);
                }
                var chunks = [];
                chunks = tempQuery.replace('/FilteredTo/', '').split('/');
                var keepChunks = [chunks[1], chunks[2]];
                storedCall += `|/${keepChunks.join('/')}`;
            } else {
                storedCall += `|${query}`;
            }
        }
        return new Promise((resolve, reject) => {
            // do some escaping of special chars for now its just underscores
            if (query && query.indexOf('FilteredTo') > -1) {
                // only escape _ when using LK
                if (query.indexOf('LK') > -1) {
                    query = query.replace(/_/g, '%5c_');
                }
            }
            if (this.requestMap[storedCall] && method === 'get') {
                this.requestMap[storedCall].sub.complete('canceled');
                delete this.requestMap[storedCall];
            }

            this.requestMap[storedCall] = {};
            this.requestMap[storedCall].resolve = resolve;
            this.requestMap[storedCall].reject = reject;

            // For gets and deletes, options is the second param
            let arg2 = options;
            let arg3 = null;

            // For everything else, its the third due to passing a body.
            if (method !== 'get' && method !== 'delete'){
                arg3 = options;
                arg2 = data;
            }
            
            this.requestMap[storedCall].sub = this.http[method](`${this.targetURL}${entity}${query || ''}`, arg2, arg3)
                .subscribe(
                    (results) => {
                        if (this.requestMap[storedCall] && method === 'get') {
                            delete this.requestMap[storedCall];
                        }
                        if (results && !results.Error) { // if not returning error,
                            // we has results
                            resolve(results);
                        } else {
                            if (results && results.Error && results.status === 401) {
                                this.nav.setRoot('LoginPage');
                                // Kick out to login screen
                                reject('not_logged_in');
                            } else {
                                results && results.hasOwnProperty('Error') ? reject(results.Error) : reject(results);
                                // can also do some niceties here like sending back to login when not authenticated etc
                            }
                        }
                    },
                    (err) => {
                        console.error('Stub Service:', err);
                        var message = '';
                        switch(err.status) {
                            case 0:
                                message = 'Network Error';
                                break;
                            case 404:
                                message = 'Unable to locate service request';
                                break;
                            default:
                                message = err.StatusText;
                                break;
                        }
                        reject(message);
                    });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/stub-service/stub.service.ts